export default "__VITE_ASSET__CvRuPCyw__"